import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
import Box from './Box';
var Flex = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
export default Flex;
var templateObject_1;
